import { connect } from 'react-redux';
import { signup } from '../actions/session';
import { Signup } from '../presentation/Signup';
import { sendSignupOAuthCode } from '../actions/session';


const mapStateToProps = state => ({
  session: { ...state.session },
});

const mapDispatchToProps = dispatch => ({
  signup: payload => dispatch(signup(payload)),
  sendSignupOAuthCode: payload => dispatch(sendSignupOAuthCode(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Signup);



// WEBPACK FOOTER //
// ./scripts/containers/SignupContainer.jsx